import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

const initialState = {};

const actionHandlers = {
    [actions.FETCH_BASE_PAGE_DATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            ...payload.response.header
        };
    }
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/reducers/header.js